"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIntegrationElement = void 0;
const axios_1 = require("axios");
const endpoints_1 = require("../../../../utils/endpoints");
const preloader_1 = require("../../../../lib/layout/preloader");
const dom_utils_1 = require("../../../../utils/dom-utils");
const utils_1 = require("./utils");
const integrationData_1 = require("./integrationData");
const endpoints = new endpoints_1.default();
const filterButtons = (0, dom_utils_1.queryAll)('.integrations__button');
const integrationSlider = (0, dom_utils_1.elementId)('integrationSlider');
const hasButton = (integrationSlider === null || integrationSlider === void 0 ? void 0 : integrationSlider.getAttribute('data-button')) === 'true';
const emptyInfo = document.getElementById('empty-info');
const showMoreButton = document.querySelector('.integrations__more');
let integrations = [];
let fetchedIntegrationIds = [];
function fetchIntegrations() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            (0, preloader_1.enablePreloader)(true, integrationSlider);
            const response = yield axios_1.default.get(`${endpoints.baseApiUrl}${endpoints.integrationsAll}`);
            yield createIntegration(response.data);
            fetchedIntegrationIds = response.data.map((integration) => integration.id.toString());
            handleFilterButtonClick();
            handleCloseModal();
            updateIntegrationDisplay();
            checkUrlHash();
        }
        catch (error) {
            console.error('Error fetching integrations:', error);
        }
        finally {
            (0, preloader_1.enablePreloader)(false, integrationSlider);
        }
    });
}
function createIntegration(integrationsList) {
    return __awaiter(this, void 0, void 0, function* () {
        integrationsList.forEach(i => {
            const integrationElement = createIntegrationElement(i);
            integrationSlider.appendChild(integrationElement);
        });
        integrations = (0, dom_utils_1.queryAll)('.integration-item');
        handleIntegrationButtonClick();
    });
}
function createIntegrationElement(integrationData) {
    const integration = document.createElement('article');
    integration.classList.add('integration-item');
    integration.setAttribute('data-type', integrationData.category);
    integration.appendChild((0, utils_1.createIntegrationElements)('label', 'integration-item__label', (0, utils_1.mapCategory)(integrationData.category)));
    const imgWrapper = (0, utils_1.createIntegrationElements)('figure');
    imgWrapper.appendChild((0, utils_1.createIntegrationElements)('img', 'integration-item__img', '', ['src', integrationData.icon_url]));
    integration.appendChild(imgWrapper);
    integration.appendChild((0, utils_1.createIntegrationElements)('h3', 'integration-item__title', integrationData.name));
    integration.appendChild((0, utils_1.createIntegrationElements)('div', 'integration-item__desc', integrationData.short_desc));
    hasButton && integration.appendChild((0, utils_1.createIntegrationElements)('button', 'integration-item__btn', 'Read More', ['data-id', integrationData.id]));
    return integration;
}
exports.createIntegrationElement = createIntegrationElement;
function updateIntegrationDisplay() {
    var _a;
    const maxVisible = 6;
    const activeFilter = (_a = filterButtons.find(button => button.classList.contains('active'))) === null || _a === void 0 ? void 0 : _a.getAttribute('data-type');
    integrations.forEach((integration, index) => {
        integration.style.display = (activeFilter === 'ALL' && index < maxVisible) ? 'block' : 'none';
    });
    showMoreButton.style.display = (integrations.length > maxVisible && activeFilter === 'ALL') ? 'block' : 'none';
}
function filterIntegrations(type) {
    integrations.forEach(integration => {
        integration.style.display = (type === 'ALL' || integration.getAttribute('data-type') === type) ? 'block' : 'none';
    });
}
function handleFilterButtonClick() {
    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            filterButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            const type = button.getAttribute('data-type') || 'ALL';
            filterIntegrations(type);
            const matchingElements = Array.from(integrations).filter(integration => type === 'ALL' || integration.getAttribute('data-type') === type);
            emptyInfo === null || emptyInfo === void 0 ? void 0 : emptyInfo.classList.toggle('d-none', matchingElements.length > 0);
            if (type === 'ALL') {
                updateIntegrationDisplay();
            }
            else {
                showMoreButton.style.display = 'none';
            }
        });
    });
}
function handleShowMoreButtonClick() {
    showMoreButton.addEventListener('click', () => {
        integrations.forEach(integration => {
            integration.style.display = 'block';
        });
        showMoreButton.style.display = 'none';
    });
}
function handleIntegrationButtonClick() {
    const overlay = document.getElementById('overlay');
    const popupOverlay = document.getElementById('popup-overlay');
    const popup = document.getElementById('popup');
    (0, dom_utils_1.queryAll)('.integration-item__btn').forEach(button => {
        button.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
            const id = button.getAttribute('data-id');
            if (id) {
                updateUrlHash(id);
                try {
                    const response = yield axios_1.default.get(`${endpoints.baseApiUrl}${endpoints.integrationsById}${id}`);
                    (0, integrationData_1.fillModal)(response.data);
                    overlay.classList.add('show');
                    popupOverlay.classList.add('show');
                    popup.classList.add('show');
                    document.body.classList.add('no-scroll');
                }
                catch (error) {
                    console.error('Error fetching integration details:', error);
                }
            }
        }));
    });
}
const openIntegrationPopup = (id) => __awaiter(void 0, void 0, void 0, function* () {
    console.log('Opening integration popup for ID:', id);
    const overlay = document.getElementById('overlay');
    const popupOverlay = document.getElementById('popup-overlay');
    const popup = document.getElementById('popup');
    try {
        const response = yield axios_1.default.get(`${endpoints.baseApiUrl}${endpoints.integrationsById}${id}`);
        (0, integrationData_1.fillModal)(response.data);
        overlay.classList.add('show');
        popupOverlay.classList.add('show');
        popup.classList.add('show');
        document.body.classList.add('no-scroll');
    }
    catch (error) {
        console.error('Error fetching integration details:', error);
    }
});
function handleCloseModal() {
    const overlay = document.getElementById('overlay');
    const popupOverlay = document.getElementById('popup-overlay');
    const popup = document.getElementById('popup');
    const closeButton = document.querySelector('.close');
    closeButton.addEventListener('click', () => {
        closeModal(overlay, popupOverlay, popup);
        updateUrlHash(null);
    });
    popupOverlay.addEventListener('click', (event) => {
        if (event.target === popupOverlay) {
            closeModal(overlay, popupOverlay, popup);
            updateUrlHash(null);
        }
    });
}
function closeModal(overlay, popupOverlay, popup) {
    overlay.classList.remove('show');
    popupOverlay.classList.remove('show');
    popup.classList.remove('show');
    document.body.classList.remove('no-scroll');
    (0, integrationData_1.resetModal)();
}
const updateUrlHash = (id) => {
    const currentUrl = new URL(window.location.href);
    if (id) {
        currentUrl.hash = `id=${id}`;
        history.replaceState(null, '', currentUrl.toString());
    }
    else {
        currentUrl.hash = '';
        history.replaceState(null, '', currentUrl.toString());
    }
};
const checkUrlHash = () => {
    const currentUrl = new URL(window.location.href);
    const hash = currentUrl.hash;
    if (hash.startsWith('#id=')) {
        const id = hash.slice(4);
        if (fetchedIntegrationIds.includes(id.toString())) {
            openIntegrationPopup(id);
        }
        else {
            console.log('ID not found in fetchedIntegrationIds:', id);
        }
    }
};
document.addEventListener('DOMContentLoaded', () => {
    if (integrationSlider) {
        fetchIntegrations();
        filterIntegrations('ALL');
        handleShowMoreButtonClick();
    }
});
